import React from 'react';

export const TipReactions = ({ options, myReaction, onReact, busy }) => {
  if (!options?.length) return null;
  return (
    <div className="mt-4 pt-3 border-t border-stone-100" data-testid="tip-reactions">
      <p className="text-[10px] sm:text-[11px] uppercase tracking-wider text-stone-400 mb-2">
        {myReaction ? 'Intel received! Tap to change your response.' : "Intel received? Tap a response to check in and close today's intel loop."}
      </p>
      <div className="grid grid-cols-3 gap-1.5 sm:flex sm:flex-wrap sm:gap-2">
        {options.map((o) => {
          const selected = myReaction === o.key;
          return (
            <button
              key={o.key}
              type="button"
              disabled={busy}
              onClick={() => onReact(o.key)}
              data-testid={`tip-reaction-${o.key}`}
              aria-pressed={selected}
              className={`flex flex-col items-center justify-center text-center gap-0.5 rounded-2xl px-1.5 py-1.5 leading-tight text-[10.5px] sm:inline-flex sm:flex-row sm:gap-1 sm:rounded-full sm:px-2.5 sm:py-1 sm:text-xs border transition-[background-color,border-color,transform] active:scale-95 disabled:opacity-60 ${
                selected
                  ? 'bg-[#F6B9A3]/30 border-[#E9967A] text-stone-900 font-medium'
                  : 'bg-white border-stone-200 text-stone-600 hover:border-[#E9967A]/70 hover:bg-[#F6B9A3]/10'
              }`}
            >
              <span aria-hidden="true" className="text-sm sm:text-xs">{o.emoji}</span>
              <span>{o.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
